<template>
  <v-autocomplete
    :dense="dense"
    v-model="selectedUsager"
    ref="usagerAutocomplete"
    :items="usagerSearchItems"
    :loading="isLoading"
    no-filter
    :search-input.sync="searchUsager"
    item-value="usagerId"
    :hide-details="hideDetails"
    :label="computedLabel"
    :rules="[(v) => !!v]"
    clearable
    :required="required"
    return-object
    :readonly="readonly"
    :disabled="readonly"
    :multiple="multiple"
    :chips="multiple"
    closable-chips
  >
    <template #selection="{ item }">
      <span>{{ item.etatCivil.nomComplet.nom }} {{ item.etatCivil.nomComplet.prenom }}</span>
    </template>
    <template v-slot:chip="{ props, item }">
      <v-chip close v-bind="props">{{ item.etatCivil.nomComplet.nom }} {{ item.etatCivil.nomComplet.prenom }}</v-chip>
    </template>
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title>
          {{ item.etatCivil.nomComplet.nom }} {{ item.etatCivil.nomComplet.prenom }}
        </v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'usager-autocomplete',
  props: {
    value: {
      type: undefined,
      required: false,
      default: undefined,
    },
    label: {
      type: String,
      required: false,
      default: 'Usager',
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    dense: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
    usagersAExclure: {
      type: Array,
      required: false,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      listUsager: undefined,
      selectedUsager: undefined,
      searchUsager: '',
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      getUsagers: 'usager/getUsagers',
      selectedEtablissement: 'application/getSelectedEtablissement',
    }),
    usagerSearchItems() {
      return this.listUsager ? this.listUsager : this.getUsagers
    },
    computedLabel() {
      if (this.required) {
        return this.label + '*'
      } else {
        return this.label
      }
    },
  },
  created() {
    this.fetchUsagersParEtablissement(this.selectedEtablissement.etablissementId)
    if (this.value) {
      this.selectedUsager = this.value
    }
  },
  watch: {
    selectedUsager() {
      if (this.selectedUsager !== this.value) {
        this.$emit('input', this.selectedUsager)
      }
    },
    value() {
      this.selectedUsager = this.value
    },
    searchUsager() {
      // Items have already been requested
      if (this.searchUsager !== null && this.searchUsager !== '') {
        if (!this.isLoading) {
          this.isLoading = true
          // Lazily load input items
          this.debouncedSearch()
        }
      }
    },
  },
  methods: {
    ...mapActions({
      searchUsger: 'usager/recherche',
      fetchUsagersParEtablissement: 'usager/fetchUsagersParEtablissement',
    }),
    reset(usager) {
      this.selectedUsager = usager
    },
    debouncedSearch: _.debounce(function () {
      this.searchUsger({
        recherche: this.searchUsager,
        etablissementId: this.selectedEtablissement.etablissementId,
      })
        .then((result) => {
          this.listUsager = result
        })
        .finally(() => (this.isLoading = false))
    }, 500),
  },
}
</script>

<style scoped></style>
